export default {"src":"/_next/static/media/icon_question.f6205a5a.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};